module.exports = __webpack_public_path__ + "img/clientlogin.6d9ff9f2.svg";